module.exports = __webpack_public_path__ + "static/media/5.0ea7b4f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trolls-girl/trinket/5.png
// module id = 99
// module chunks = 0